export const apiUrl = "https://api.clinicasandiegocucuta.com/api/";
export const recaptchaKey = "6Lc43jgeAAAAAGyrCW2uTrKF0RP-XdR0Wb0gkjne"

// export const apiUrl = "https://apicsd.nelumbo.com.co/api/"; //QA
// export const apiUrl = "https://apicsddev.nelumbo.com.co/api/" //DEV